import styled, { css } from 'styled-components';

export const ModalHeader = styled.div`
  display: flex;
  height: 56px;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  position: relative;
`;

export const ModalTitle = styled.div`
  flex: 1 0 0;
  color: #222;
  text-align: center;
  font-size: 18px;
  font-weight: 700;
  line-height: 145%;
  letter-spacing: -0.36px;
`;

export const ModalCloseButton = styled.img`
  position: absolute;
  top: 16px;
  right: 16px;

  width: 24px;
  height: 24px;
`;

export const ModalFooter = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  border-top: 1px solid rgba(112, 115, 124, 0.22);
  background: #fff;
`;

const Button = styled.button<{ $disabled?: boolean }>`
  border: none;
  outline: none;

  display: flex;
  padding: 14px 28px;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  background: rgba(112, 115, 124, 0.08);

  color: #616161;
  text-align: center;
  font-size: 16px;
  font-weight: 500;
  line-height: 145%;
  letter-spacing: -0.32px;

  ${({ $disabled }) =>
    $disabled &&
    css`
      && {
        background: #f7f7f8;
        color: #37383c29;
        pointer-events: none;
      }
    `}
`;

export const CancleButton = styled(Button)`
  background: rgba(112, 115, 124, 0.08);
  color: #616161;
`;

export const ConfirmButton = styled(Button)`
  flex: 1 0 0;
  background: #008aff;
  color: #fff;
`;
